import { Button, CircularProgress, Theme } from "@material-ui/core";
import { StyleRulesCallback } from "@material-ui/core/styles/withStyles";
import { makeStyles } from "@material-ui/styles";
import React from "react";

interface FormButtonProps {
  waiting?: boolean;
  testId: string;
  label: string;
  fullWidth?: boolean;
  color?: "inherit" | "primary" | "secondary" | "default" | undefined;
  disabled?: boolean;
  name?: string;
}

const useStyles = makeStyles(
  (theme: Theme) =>
    ({
      submit: {
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.common.white,
      },
      loader: {
        alignSelf: "center",
      },
    } as unknown as StyleRulesCallback<Theme, Record<string, unknown>, string>),
);

const FormButton: React.FC<FormButtonProps> = ({
  waiting,
  testId,
  label,
  fullWidth,
  color,
  disabled,
  name,
}) => {
  const classes = useStyles({}) as Record<string, string>;
  if (waiting) {
    return (
      <CircularProgress className={classes.loader} data-testid="loading" />
    );
  }
  return (
    <Button
      className={classes.submit}
      data-testid={testId}
      type="submit"
      size="large"
      variant="contained"
      color={color || "secondary"}
      fullWidth={!!fullWidth}
      disabled={disabled}
      name={name}
    >
      {label}
    </Button>
  );
};

export default FormButton;
